import { Component, Input, Output, OnInit,EventEmitter } from '@angular/core';
import { Service } from '../../class/service';
import { Search } from '../../class/search';
import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'search-component',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
    @Input() search: Search;
    private _open:boolean = false;
    @Input() set open(b:boolean){
        if(b){
            this._open = b;
            if(this.search.toSearch != undefined || this.search.toSearch != null){
                if(this.search.toSearch != ''){
                    this.getList(1,this.search.toSearch);
                }
            }
        }
    }
    @Output() getData = new EventEmitter<Object>();
    
    private extra: Object = { search: '' };
    private searchComp = new FormControl();
    private loader:boolean = false;
    private pagination: Array<any>;
    private pages: Array<number> = [];

    constructor(private service:Service){}

   

    ngOnInit(){
        this.searchComp.valueChanges
        .debounceTime(700).subscribe(a => {
            if(a != null || a != undefined){
                if(this._open){
                    this.getList(1,a);
                }
            }
        });
    }
    
    private close(){
        this._open = false;
        this.getData.emit({ open: false,data:{} });
        this.clear();
    }

    private selected(data:Object){
        this._open = false;
        this.getData.emit({ open: false, data: data });
        this.clear();
    }
    private clear():void{
        this.pagination = undefined;
        this.extra["search"] = "";
    }
    private getList(page: number, search: string): void {
        this.loader = !this.loader;
        this.service.GET(this.search.service, "&page=" + page + "&search=" + (search || '')).subscribe(res => {
            this.pagination = res["data"];
            this.pages = [];
            var it = 1;
            var limit = 10;
            var ex = 0;
            for (var _i = 1; _i <= limit; _i++) {
                ex++;
                var num = _i;
                if (this.pagination["current_page"] > 6) {
                    num += this.pagination["current_page"] - 6;
                }
                
                if (num > this.pagination["last_page"]) {
                    ex = ex - limit - 1;
                    break;
                }
            }
            
            for (var _i = 1; _i <= limit; _i++) {
                var num = _i;
                if (ex < 0) {
                    num = num + ex;
                }
                
                if (this.pagination["current_page"] > 6) {
                    num += this.pagination["current_page"] - 6;
                }
                if (num > this.pagination["last_page"]) {
                    break;
                }
                
                if (num > 0) {
                    this.pages.push(num);
                }
            }
            this.loader = !this.loader;
        }, err => {
            console.log(err);
            this.loader = !this.loader;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/component/search/search.component.ts